import React from "react";
import * as asyncState from "../../../Utils/asyncState";
import { toast } from "react-toastify";
import { membershipUpgrade } from "../../../Service/update_profile";
import { getUserID } from "../../../Service/getLocalStorage";
import { usePostHog } from "posthog-js/react";

const useUpdateTariff = () => {
  const posthog = usePostHog();

  const [changeTariffRequestStatus, setChangeTariffRequestStatus] =
    React.useState(asyncState.initState);

  const changeTariff = async ({
    membershipId,
    successCB,
  }: {
    membershipId: number;
    successCB: (data: any) => void;
  }) => {
    try {
      setChangeTariffRequestStatus(asyncState.pendingState);
      const res: any = await membershipUpgrade({
        user_id: getUserID(),
        membership_id: membershipId,
      });

      if (res.status !== 200) {
        throw { message: res?.data?.message?.join(" ") };
      }

      setChangeTariffRequestStatus(asyncState.successState);
      successCB({
        trialEnd: res?.data?.data?.trial_end * 1000,
        membershipId: membershipId,
      });

      posthog.capture("user-changed-membership", {
        $set: {
          free_membership: false,
          monthly_membership: membershipId === 1,
          annual_membership: membershipId === 2,
        },
      });
    } catch (err: { message: string } | any) {
      toast.error(err?.message);
      setChangeTariffRequestStatus({
        ...asyncState.failedState,
        failedMessage: err?.message,
      });
    }
  };

  return {
    changeTariff: changeTariff,
    changeTariffRequestStatus,
  };
};

export default useUpdateTariff;
